export default "__VITE_ASSET__17eb43d5__"